import { getSmartOAuthErrorMessageFromUrlCode } from "@/lib/smart-oauth-errors";

export interface AuthErrorToast {
  code: string;
  title: string;
  description: string;
}

const AUTH_ERROR_TITLES: Record<string, string> = {
  access_denied: "Connection canceled",
  account_already_linked: "Portal already linked",
  account_exists: "Portal already linked",
  state_expired: "Connection expired",
  state_not_found: "Connection expired",
  invalid_state: "Connection expired",
};

function humanizeErrorCode(code: string) {
  return code
    .split("_")
    .filter(Boolean)
    .map((part) => part[0]?.toUpperCase() + part.slice(1))
    .join(" ");
}

export function getAuthErrorToast(
  errorCode: string | null,
  errorDescription?: string | null,
): AuthErrorToast | null {
  const code = errorCode?.trim().toLowerCase();
  if (!code) {
    return null;
  }

  const mappedDescription =
    errorDescription?.trim() ||
    getSmartOAuthErrorMessageFromUrlCode(code) ||
    "We couldn't complete the connection. Please try again.";

  return {
    code,
    title: AUTH_ERROR_TITLES[code] || humanizeErrorCode(code) || "Connection error",
    description: mappedDescription,
  };
}

export function readAuthErrorFromUrl(url: string): AuthErrorToast | null {
  const parsedUrl = new URL(url, "http://localhost");
  const errorCode = parsedUrl.searchParams.get("error");
  const errorDescription = parsedUrl.searchParams.get("error_description");
  return getAuthErrorToast(errorCode, errorDescription);
}
